<template>
	<div class="container" v-if="list.length >0">
        <div class="panel panel-default">
            <div class="panel-heading">
                <div class="category">
                    <a class="category-top">{{name}}</a>
                    <a class="category-bottom">{{enname}}</a>
                </div>
            </div>
            <div class="panel-body " style="padding:0px;">
                <van-row>
                  <van-col span="12" v-for="(item, index) in list">
                    <a :href="item.LinkUrl" class="thumbnail retailer">
                      <van-image
                        width="100%"
                        lazy-load
                        :src="item.img_url"
                      />   
                    </a>
                  </van-col>
                </van-row>

            </div>
        </div>
    </div>
</template>
<script>

export default {
  data(){
    return {
      show: false,
    }
  },
  props: {
  	list: {
  		type: Array||Object,
  		require: true
  	},
  	name: {
  		type: String,
  		default: '电商预订'
  	},
  	enname: {
  		type: String,
  		default: 'Online retailers'
  	}
  },
  components: {  },
  mounted: function () {
  },
  methods: {
  }
};

</script>
<style>
.container .thumbnail img {
  height: 50px;
  width: auto;
  display: inline;
  line-height: 50px;

}
.container .thumbnail .van-image{
  width: 100%;
  text-align: center;
      height: 50px;
}
.thumbnail{
  border-radius: 8px;
  overflow: hidden;
}
</style>
